import { EventModel } from 'src_common/common/websocket2/models/EventModel';
import { action, computed, observable, makeAutoObservable } from 'mobx';
import { SdkStaff } from 'src/AppState/sdk/staff';
import { EventId } from 'src_common/common/websocket2/id/WebsocketId';

interface PostBodyTypes {
    feedSettings?: {
        updates?: boolean;
        results?: boolean;
        eachWay?: boolean;
        prices?: boolean;
    };
}
export class FeedsState {
    @observable isLoadingEventUpdate: boolean = false;

    public constructor(
        private readonly eventIdInner: () => EventId,
        private readonly sdkStaff: SdkStaff
    ) {
        makeAutoObservable(this);
    }

    @computed get eventId(): EventId {
        return this.eventIdInner();
    }

    @computed get eventModel(): EventModel | null {
        return this.eventId.getEventModel();
    }

    @computed get feedSettingsUpdates(): boolean | undefined {
        return this.eventModel?.feedSettingsUpdates ?? undefined;
    }

    @computed get feedSettingsResults(): boolean | undefined {
        return this.eventModel?.feedSettingsResults ?? undefined;
    }

    @computed get feedSettingsEachWay(): boolean | undefined {
        return this.eventModel?.feedSettingsEachWay ?? undefined;
    }

    @computed get feedSettingsPrices(): boolean | undefined {
        return this.eventModel?.feedSettingsPrices ?? undefined;
    }

    @action onChangeFeedSettingsUpdates = async (e: React.ChangeEvent<HTMLInputElement>): Promise<void> => {
        const updates = e.currentTarget.checked;

        await this.performUpdate({
            feedSettings: {
                updates,
            },
        });
    };

    @action onChangeFeedSettingsResults = async (e: React.ChangeEvent<HTMLInputElement>): Promise<void> => {
        const results = e.currentTarget.checked;

        await this.performUpdate({
            feedSettings: {
                results,
            },
        });
    };

    @action onChangeFeedSettingsEachWay = async (e: React.ChangeEvent<HTMLInputElement>): Promise<void> => {
        const eachWay = e.currentTarget.checked;

        await this.performUpdate({
            feedSettings: {
                eachWay,
            },
        });
    };

    @action onChangeFeedSettingsPrices = async (e: React.ChangeEvent<HTMLInputElement>): Promise<void> => {
        const prices = e.currentTarget.checked;

        await this.performUpdate({
            feedSettings: {
                prices,
            },
        });
    };

    @action performUpdate = async (body: PostBodyTypes): Promise<void> => {
        this.isLoadingEventUpdate = true;
        await this.sdkStaff.updateEvent({ event_id: this.eventId.toOldId(), requestBody: body });
        this.isLoadingEventUpdate = false;
    };
}
